import React, { useMemo, useEffect, useState } from 'react';
import Header from './Header';

import StatisticsStream from './StatisticsStream';
import ArchiveManager from './ArchiveManager';
import { useDataStore } from '../stores/data/dataStore';
import { feManagementSystemApi, TokenStreamDeck } from '../api/fe-management-system-api';

const PulseDashboard: React.FC<{ isConnected: boolean, reconnectAttempts: number }> = ({ isConnected, reconnectAttempts }) => {
  const { tokenStateMap } = useDataStore();
  const [decks, setDecks] = useState<TokenStreamDeck[]>([]);
  const [isLoadingDecks, setIsLoadingDecks] = useState(true);

  // Deck 리스트 가져오기
  useEffect(() => {
    const fetchDecks = async () => {
      try {
        setIsLoadingDecks(true);
        const deckList = await feManagementSystemApi.getAllTokenStreamDecks();
        setDecks(deckList);
      } catch (error) {
        console.error('Failed to fetch decks:', error);
        setDecks([]);
      } finally {
        setIsLoadingDecks(false);
      }
    };

    fetchDecks();
  }, []);

  const pulseDataItems = useMemo(() => {
    // 덱별 필터를 사용하므로 여기서는 기본 데이터만 반환c
    return Object.values(tokenStateMap).map((data) => ({
      ...data,
      tokenAddress: data.tokenAddress,
    }));
  }, [tokenStateMap]);

  // 덱별 필터를 사용하므로 여기서는 기본 데이터만 반환 (아카이브 필터링은 useDeckFilter에서 처리)
  const filteredPulseData = useMemo(() => {
    return pulseDataItems;
  }, [pulseDataItems]);

  return (
    <div className="min-h-screen bg-gray-900 text-white">
      <Header title="AF Monitor" showPageControls={true} />

      <main className="max-w-8xl mx-auto p-8 pr-0">
        <ArchiveManager />
        
        <div className="flex space-x-2 overflow-x-auto pb-4" id="decks-container">
          {isLoadingDecks ? (
            <div className="text-gray-400 p-4">Loading decks...</div>
          ) : decks.length === 0 ? (
            <div className="text-gray-400 p-4">No decks found</div>
          ) : (
            decks.map((deck) => (
              <StatisticsStream
                key={deck.id}
                data={filteredPulseData}
                isConnected={isConnected}
                reconnectAttempts={reconnectAttempts}
                defaultSortType={deck.sort.field as any}
                filter={deck.filter}
                deckId={deck.id}
                name={deck.name}
              />
            ))
          )}
        </div>
      </main>
    </div>
  );
};

export default PulseDashboard; 